// extracted by mini-css-extract-plugin
export default {"hidden":"PhysicalConnectionSelector_hidden__9yydN","selected":"PhysicalConnectionSelector_selected__Gh6Ry"};